@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container-fluid p-3 mb-5 content">
        <div class="row justify-content-between align-items-center">
            <div class="w-fit">
                <app-back-button routerLink="/claims" component="Claims"></app-back-button>
            </div>
            <div class="col-auto d-flex justify-content-end align-items-center">
                <button mat-raised-button class="action-button d-flex col-auto align-items-center" style="margin-right:8px" (click)="onModifyClaimClick()">
                    <mat-icon class="edit-inquire-button-icon">edit</mat-icon>
                    Modify Claim
                </button>
                <button mat-raised-button *ngIf="claim?.is_active" class="action-button d-flex col-auto align-items-center" style="margin-right:8px" (click)="onUpdateClaimStatusClick()">
                    <mat-icon class="edit-inquire-button-icon">edit</mat-icon>
                    Update Claim Status
                </button>
                <button mat-raised-button *ngIf="claim?.is_active && claim?.status_id != 3" class="warn-button d-flex col-auto align-items-center" (click)="onDeleteClaimClick()">
                    <mat-icon class="edit-inquire-button-icon">delete</mat-icon>
                    Delete Claim
                </button>
                <button mat-raised-button *ngIf="!claim?.is_active" class="warn-button d-flex col-auto align-items-center" (click)="onUndeleteClaimClick()">
                    <mat-icon class="edit-inquire-button-icon">delete</mat-icon>
                    Undelete Claim
                </button>
                <button mat-raised-button class="action-button d-flex col-auto align-items-center" style="margin-left:8px;" (click)="onInquireOpenClick()">
                    <mat-icon class="edit-inquire-button-icon">email</mat-icon>
                    Inquire
                </button>
                <button mat-raised-button class="action-button d-flex col-auto align-items-center" style="margin-left:8px;" (click)="onPaymentReceivedClick()">
                    <mat-icon class="edit-inquire-button-icon">attach_money</mat-icon>
                    Claim Benefits
                </button>
            </div>
        </div>
        <div class="row align-items-center mt-3">
            <div class="col-xl-9 col-12">
                <div class="row">
                    <h1 class="header">
                        Claim #{{ claim?.id }}
                        <span class="text-muted property-name" *ngIf="claim?.property?.property_name">
                            <span class="property-name-separator">|</span> {{ claim?.property?.property_name }}
                        </span>
                    </h1>
                </div>
                <div class="row mt-1">
                    <div class="d-flex">
                        <div class="col-12">
                            Organization ID: 
                            <span class="text-bold" (click)="onViewClaimOrganizationClick()">
                                <a>{{ claim?.organization_id }}</a>
                            </span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-12">
                            Organization Name: 
                            <span class="text-bold" (click)="onViewClaimOrganizationClick()">
                                <a>{{ claim?.organization?.name }}</a>
                            </span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-12">
                            Safely Property ID: 
                            <span class="text-bold" (click)="onViewClaimPropertyClick()">
                                <a>{{ claim?.property_id }}</a>
                            </span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-12">
                            Property ID: 
                            <span class="text-bold" (click)="onViewClaimPropertyClick()">
                                <a>{{ claim?.property?.reference_id }}</a>
                            </span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-12">
                            Safely Reservation ID: 
                            <span class="text-bold" (click)="onViewClaimReservationClick()">
                                <a>{{ claim?.reservation_id }}</a>
                            </span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-12">
                            Reference ID: 
                            <span class="text-bold">{{ claim?.reservation?.reference_id }}</span>
                        </div>
                    </div>
                    <div *ngIf="reservation.guests.length > 0" class="d-flex">
                        <div class="col-12">
                            Guest Name: 
                            <span class="text-bold" (click)="onViewReservationGuestClick()">
                                <a>{{ reservation.guests[0].first_name }} {{ reservation.guests[0].last_name }}</a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-12 d-flex align-items-center date-display-container">
                <app-claim-detail-date-display style="margin-right:5px;" [date]="claim?.reservation?.arrival_date"
                    detail="arrival"></app-claim-detail-date-display>
                <div class="date-display-line"></div>
                <app-claim-detail-date-display style="margin-left:5px;" [date]="claim?.reservation?.departure_date"
                    detail="departure"></app-claim-detail-date-display>
            </div>
        </div>
        <div class="row mt-3">
            <hr style="height: 1.5px" />
        </div>
        <div class="claim-detail-columns-container mt-3">
            <div class="claim-detail-container">
                <mat-card appearance="outlined" class="mat-elevation-z3 mb-2">
                    <div *ngIf="loadingClaimDetails; else claim_property_details_content" class="claim-detail-loading">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ng-template #claim_property_details_content>
                        <div class="row mb-3">
                            <div class="col-12">
                                <mat-card-title>Property Details</mat-card-title>
                            </div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Property Name</div>
                            <div class="col-lg-8 col-12 detail-text" (click)="onViewClaimPropertyClick()">
                                <a>{{ reservation.property.property_name }}</a>
                            </div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Address</div>
                            <div class="col-lg-8 col-12 detail-text">
                                {{ reservation.property.address.address_line_1 }} {{ reservation.property.address.address_line_2 }}<br>
                                {{ reservation.property.address.city }}, {{ reservation.property.address.state }}  {{ reservation.property.address.postal_code }}
                            </div>
                        </div>
                        <div *ngIf="reservation.property.property_owner_name" class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Homeowner</div>
                            <div class="col-lg-8 col-12 detail-text">
                                {{ reservation.property.property_owner_name }}
                            </div>
                        </div>
                        <div *ngIf="reservation.property.property_owner_email" class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Homeowner Email</div>
                            <div class="col-lg-8 col-12 detail-text">
                                {{ reservation.property.property_owner_email }}
                            </div>
                        </div>
                        <div *ngIf="reservation.property.property_owner_phone" class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Homeowner Phone</div>
                            <div class="col-lg-8 col-12 detail-text">
                                {{ reservation.property.property_owner_phone }}
                            </div>
                        </div>
                        <ng-container *ngIf="reservation.property.photos">
                            <div *ngIf="reservation.property.photos.length > 0" class="row">
                                <div class="col-12" style="text-align:center;">
                                    <img [src]="reservation.property.photos[0].url" class="rounded photo m-2" width="300px"/>
                                </div>
                            </div>
                        </ng-container>
                    </ng-template>
                </mat-card>
                <mat-card appearance="outlined" class="mat-elevation-z3 claim-detail-card">
                    <div *ngIf="loadingClaimDetails;else claim_details_content" class="claim-detail-loading">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ng-template #claim_details_content>
                        <div class="row mb-3">
                            <div class="col-12">
                                <mat-card-title>Claim Details</mat-card-title>
                            </div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Date of Loss</div>
                            <div class="col-lg-8 col-12 detail-text">{{ claim?.damage_date }}</div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Type of Loss</div>
                            <div class="col-lg-8 col-12 detail-text">
                                <div class="row">
                                    <div *ngFor="let claimReason of claimReasons" class="col-12">
                                        {{ claimReason }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Description</div>
                            <div class="col-lg-8 col-12 detail-text">{{ claim?.damage_description }}</div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Is the home livable</div>
                            <div class="col-lg-8 col-12 detail-text">{{ claim?.home_liveable }}</div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Rent to this guest again?</div>
                            <div class="col-lg-8 col-12 detail-text">{{ claim?.would_rent_again }}</div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Guest negligence</div>
                            <div class="col-lg-8 col-12 detail-text">{{ getClaimNegligenceDescription(claim?.guest_rate) |
                                titlecase }}</div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Estimated Claim Amount</div>
                            <div class="col-lg-8 col-12 detail-text">{{ formatCurrencyString(claim?.estimate_amount, userContextProvider.currencyCode) }}</div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Amount Paid</div>
                            <div class="col-lg-8 col-12 detail-text">{{ formatCurrencyString(claim?.actual_amount, userContextProvider.currencyCode) }}</div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Draft Date</div>
                            <div class="col-lg-8 col-12 detail-text">{{ dateFormat(claimDraftDate, userContextProvider.region) }}</div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Submitted Date</div>
                            <div class="col-lg-8 col-12 detail-text">{{ dateFormat(claimSubmittedDate, userContextProvider.region) }}</div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Completion Date</div>
                            <div class="col-lg-8 col-12 detail-text">{{ dateFormat(claimCompletedDate, userContextProvider.region) }}</div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Safely Admin Note</div>
                            <div class="col-lg-8 col-12 detail-text">{{ claim?.admin_comment }}</div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Additional Comments</div>
                            <div class="col-lg-8 col-12 detail-text" *ngIf="!isStringEmptyOrNull(claim?.additional_comment)">
                                <div *ngIf="(claim?.additional_comment?.length ?? 0) < 200; else collapsable_additional_comments">
                                    {{ claim?.additional_comment }}
                                </div>
                                <ng-template #collapsable_additional_comments>
                                    <div *ngIf="displayFullAdditionalComments; else collapsed_additional_comments">
                                        {{ claim?.additional_comment }} 
                                        <a class="additional-comments-link" (click)="displayFullAdditionalComments = false" style="white-space: nowrap">See less</a>
                                    </div>
                                    <ng-template #collapsed_additional_comments>
                                        {{ padString({ str: claim?.additional_comment || '', maxLength: 200, padEnd: true }) }}
                                        <a class="additional-comments-link" (click)="displayFullAdditionalComments = true">See more</a>
                                    </ng-template>
                                </ng-template>
                            </div>
                        </div>
                        <ng-container *ngIf="claim?.claim_cause_injury === 1">
                            <div class="row mt-5 mb-3">
                                <div class="col-12">
                                    <mat-card-title>Injury Details</mat-card-title>
                                </div>
                            </div>
                            <div class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">Injured Name</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.injury_name }}</div>
                            </div>
                            <div class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">Phone</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.injury_phone }}</div>
                            </div>
                            <div class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">Address Line 1</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.injury_address?.address_line_1 }}</div>
                            </div>
                            <div *ngIf="claim?.injury_address?.address_line_2" class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">Address Line 2</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.injury_address?.address_line_2 }}</div>
                            </div>
                            <div class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">City</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.injury_address?.city }}</div>
                            </div>
                            <div class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">State/Province</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.injury_address?.state }}</div>
                            </div>
                            <div class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">Postal Code</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.injury_address?.postal_code }}</div>
                            </div>
                            <div class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">Country</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.injury_address?.country_name }}</div>
                            </div>
                            <div class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">Description of Injuries</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.injury_description }}</div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="claim?.claim_cause_theft_fire === 1">
                            <div class="row mt-5 mb-3">
                                <div class="col-12">
                                    <mat-card-title>Theft/Fire Details</mat-card-title>
                                </div>
                            </div>
                            <div class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">Police/Fire Dept. Name</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.goverment_department?.name }}</div>
                            </div>
                            <div *ngIf="claim?.goverment_department?.case_number" class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">Case #</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.goverment_department?.case_number }}</div>
                            </div>
                            <div *ngIf="claim?.goverment_department?.officer_name" class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">Officer Name</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.goverment_department?.officer_name }}</div>
                            </div>
                            <div *ngIf="claim?.goverment_department?.officer_phone" class="row detail-row">
                                <div class="col-lg-4 col-12 text-muted detail-text">Officer Phone</div>
                                <div class="col-lg-8 col-12 detail-text">{{ claim?.goverment_department?.officer_phone }}</div>
                            </div>
                        </ng-container>
                        <div class="row mt-5" *ngIf="attachments.length > 0; else noAttachments">
                            <div class="col-12 d-flex align-items-center text-muted detail-text expandable-header"
                                (click)="attachmentsExpanded = !attachmentsExpanded">
                                Documents ({{ attachments.length }})
                                <mat-icon>{{ attachments.length > 0 ? 'expand_less' : 'expand_more' }}</mat-icon>
                            </div>
                        </div>
                        <ng-template #noAttachments>
                            <div class="col-12 d-flex align-items-center text-muted detail-text expandable-header">
                                Documents ({{ attachments.length }}) <mat-icon>{{ attachments.length > 0 ? 'expand_less' : 'expand_more' }}</mat-icon>
                            </div>
                        </ng-template>
                        <div class="row mt-2 documents-container" [style.display]="attachmentsExpanded ? 'block' : 'none'">
                            <div *ngFor="let document of attachments" class="row mt-4">
                                @if(document.file_id) {
                                    <app-claim-detail-document 
                                        class="claim-detail-document-link" 
                                        [fileName]="document.file_name"
                                        [description]="document.description" 
                                        (click)="onAttachmentClick(document.file_id)"
                                        (onKeyPress)="onAttachmentClick(document.file_id)"
                                        (onKeyDown)="onAttachmentClick(document.file_id)"
                                        (onKeyUp)="onAttachmentClick(document.file_id)"
                                    />
                                }
                            </div>
                        </div>
                    </ng-template>
                </mat-card>
            </div>
            <div class="claim-other-detail-container">
                <mat-card appearance="outlined" class="mat-elevation-z3">
                    <div *ngIf="loadingClaimDetails;else claim_status_content" class="claim-detail-loading">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ng-template #claim_status_content>
                        <div class="row">
                            <div class="col-12 d-flex align-items-center">
                                <div class="row">
                                    <div class="col-12">
                                        <mat-card-title>Claim Status</mat-card-title>
                                    </div>
                                    <div class="col-12 text-muted">
                                        Last Updated: {{ claimStatusLastUpdateDate }}
                                    </div>
                                </div>
                                <app-pill class="claim-status-pill" 
                                    [text]="getClaimStatusText()"
                                    [backgroundColor]="getClaimStatusColor(claim?.status_id)">
                                </app-pill>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-5">
                                <app-claim-status-detail-row statusText="1. Submitted to Safely"
                                    [state]="getClaimSubmittedState()"></app-claim-status-detail-row>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-5">
                                <app-claim-status-detail-row statusText="2. Claim under review by Safely"
                                    [state]="getClaimProcessingState()"></app-claim-status-detail-row>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-5">
                                <app-claim-status-detail-row statusText="3. Claim processed" [state]="getClaimApprovedState()">
                                </app-claim-status-detail-row>
                            </div>
                        </div>
                        @if(this.userContextProvider.isNaUser()) {
                            <div class="row my-4 text-muted">
                                Click the Inquire button to reach the Claims Team for additional assistance regarding damages for this reservation.
                            </div>
                        }
                    </ng-template>
                </mat-card>
                <mat-card appearance="outlined" class="mat-elevation-z3">
                    <div class="col-12 d-flex align-items-center my-3">
                        <mat-card-title>Policy Limits</mat-card-title>
                    </div>
                    <div class="row detail-row">
                        <div class="col-lg-6 col-12 text-muted detail-text">Policy Name</div>
                        <div class="col-lg-6 col-12 detail-text">
                            <span (click)="onViewReservationPolicyClick()">
                                <a>{{ insurancePolicy?.policy?.name }}</a>
                            </span>
                        </div>
                    </div>
                    <div class="row detail-row">
                        <div class="col-lg-6 col-12 text-muted detail-text">Contents Coverage</div>
                        <div class="col-lg-6 col-12 detail-text">{{ formatCurrencyString(insurancePolicy?.policy?.damage_coverage?.toString(), userContextProvider.currencyCode) }}</div>
                    </div>
                    <div class="row detail-row">
                        <div class="col-lg-6 col-12 text-muted detail-text">Homeowner Liability Coverage</div>
                        <div class="col-lg-6 col-12 detail-text">{{ formatCurrencyString(insurancePolicy?.policy?.liability_coverage?.toString(), userContextProvider.currencyCode) }}</div>
                    </div>
                    <div class="row detail-row mt-2">
                        <div class="col-lg-6 col-12 text-muted detail-text">Dwelling Coverage</div>
                        <div class="col-lg-6 col-12 detail-text">{{ formatCurrencyString(insurancePolicy?.policy?.dwelling_coverage?.toString(), userContextProvider.currencyCode) }}</div>
                    </div>
                    <div class="row detail-row">
                        <div class="col-lg-6 col-12 text-muted detail-text">Deductible</div>
                        <div class="col-lg-6 col-12 detail-text">{{ formatCurrencyString(insurancePolicy?.deductible?.toString(), userContextProvider.currencyCode) }}</div>
                    </div>
                </mat-card>
                <mat-card appearance="outlined" class="mat-elevation-z3" *ngIf="claim?.send_check_to || claim?.send_check_to_address || claim?.send_check_to_phone || claim?.send_check_to_email">
                    <div class="col-12 d-flex align-items-center my-3">
                        <mat-card-title>Payment Information</mat-card-title>
                    </div>
                    <div *ngIf="claim && claim.send_check_to !== 1">
                        <div class="row detail-row" *ngIf="claim?.send_check_to">
                            <div class="col-lg-6 col-12 text-muted detail-text">Send payment to: </div>
                            <div class="col-lg-6 col-12 detail-text">{{ getSendToText() }}</div>
                        </div>
                        <div class="row detail-row" *ngIf="claim?.send_check_to_address"> 
                            <div class="col-lg-6 col-12 text-muted detail-text">Address: </div> 
                            <div class="col-12 detail-text mt-1">{{ claim.send_check_to_address.address_line_1 }}</div>
                            <div *ngIf="claim.send_check_to_address.address_line_2 !== null && claim.send_check_to_address?.address_line_2.length > 0" class="col-lg-6 col-12 detail-text">{{ claim.send_check_to_address.address_line_2 }}</div>
                            <div class="col-lg-6 col-12 detail-text">{{ claim.send_check_to_address.city }}, {{
                                claim.send_check_to_address.state }} {{ claim.send_check_to_address.postal_code }}</div>
                        </div>
                        <div class="row detail-row" *ngIf="claim.send_check_to_phone || claim.send_check_to_email">
                            <div class="col-lg-6 col-12 text-muted detail-text">Contact: </div>
                             <div class="col-12 detail-text mt-1">{{ claim.send_check_to_name }}</div>
                            <div class="col-12 detail-text mt-1">{{ formatPhoneNumber(claim.send_check_to_phone, currentCountryCode) }}</div>
                            <div class="col-12 detail-text">{{ claim.send_check_to_email }}</div>
                        </div>
                    </div>
                    <div *ngIf="claim && claim.send_check_to === 1">
                        <div class="row detail-row"> 
                            <div class="col-lg-6 col-12 text-muted detail-text">Claim Payments via ACH </div>
                        </div>
                    </div>
                </mat-card>
                <mat-card appearance="outlined" class="mat-elevation-z3" style="height:100%;">
                    <div *ngIf="loadingClaimDetails; else claim_primary_contact_content" class="claim-detail-loading">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ng-template #claim_primary_contact_content>
                        <div class="row mb-3">
                            <div class="col-12">
                                <mat-card-title>Primary Contact</mat-card-title>
                            </div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Name</div>
                            <div class="col-lg-8 col-12 detail-text">
                                @if (primaryClaimContact?.last_name) {
                                    {{ primaryClaimContact?.first_name }} {{ primaryClaimContact?.last_name }}
                                } @else {
                                    No primary contact saved
                                }
                            </div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Phone</div>
                            <div class="col-lg-8 col-12 detail-text">
                                @if (primaryClaimContact?.phone_number != undefined) {
                                    {{ formatPhoneNumber(primaryClaimContact?.phone_number, currentCountryCode) }}
                                } @else {
                                    No phone saved
                                }
                            </div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-4 col-12 text-muted detail-text">Email</div>
                            <div class="col-lg-8 col-12 detail-text">
                                @if (primaryClaimContact?.email_address) {
                                    {{ primaryClaimContact?.email_address }}
                                } @else {
                                    No email saved
                                }
                            </div>
                        </div>
                    </ng-template>
                </mat-card>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <mat-card appearance="outlined" class="mat-elevation-z3 h-100">
                    <div class="row mb-3">
                        <div class="col-12">
                            <mat-card-title>Claim Status History</mat-card-title>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <table mat-table [dataSource]="claimStatusHistoryDataSource">
                            <ng-container matColumnDef="timestamp">
                                <th mat-header-cell *matHeaderCellDef>Date/Time</th>
                                <td mat-cell *matCellDef="let element">{{ dateFormat(element.timestampDate, userContextProvider.region) }} - {{ element.timestampTime }}</td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Status</th>
                                <td mat-cell *matCellDef="let element">{{ element.status }}</td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="claimStatusHistoryColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: claimStatusHistoryColumns"></tr>
                        </table>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
}